/**
 * ModuleButton Component
 * Shows currently selected module in header
 * Created: 2025-12-23 16:45 EST
 */

import './ModuleButton.css'

// Module icons mapping
const MODULE_ICONS = {
  Odds: 'fas fa-percentage',
  Stats: 'fas fa-chart-line',
  Arbitrage: 'fas fa-balance-scale',
  Middles: 'fas fa-compress-arrows-alt',
  PositiveEV: 'fas fa-chart-line',
  '+EV': 'fas fa-chart-line',
  Models: 'fas fa-brain',
  Analytics: 'fas fa-chart-bar',
  Operations: 'fas fa-server',
  Data: 'fas fa-database',
  Infrastructure: 'fas fa-network-wired',
  Tools: 'fas fa-tools',
}

function ModuleButton({ selectedModule, onClick }) {
  const icon = MODULE_ICONS[selectedModule] || 'fas fa-th-large'

  return (
    <button
      className="module-btn"
      onClick={onClick}
      title={`Current Module: ${selectedModule}`}
    >
      <i className={icon}></i>
      <span>{selectedModule}</span>
    </button>
  )
}

export default ModuleButton
